import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import {
  SelectMultiple,
  SelectOptionWithGroup as SelectOptionWithGroupTea,
} from 'tea-component';
import { imgInvert } from '@/pages/intelligence/pages/SourcesMetrics/Sources/component/ChannelLabel';
import TipContext from '@home/components/TipContextComponents/TipContext';

export interface SelectOptionWithGroup {
  value: string;
  text: React.ReactNode; // 下拉显示
  buttonText?: React.ReactNode; // button显示,主要是annie那种下拉有Hover,展示无Hover
}
export interface MulSelectorProps {
  style?: React.CSSProperties;
  className?: string;
  overlayStyle?: React.CSSProperties;
  overlayClassName?: string;
  tips?: string;
  AWidth?: any;
  listHeight?: number;
  // 勾选数量大于等于 num时，button 展示数字
  num?: number;
  value: string[]; // 默认值
  options: SelectOptionWithGroup[]; // 下拉配置
  buttonName?: string; // button格式前缀
  hasAllCheck?: boolean; // 是否有全选按钮
  disabled?: boolean;
  isShowButtonLabel?: boolean;
  onChange: (value: string[]) => void;
  searchable?: boolean;
  filter?: (inputValue: string, option: SelectOptionWithGroupTea) => boolean;
}

export default function MulSelector(props: MulSelectorProps) {
  const {
    style,
    className = '',
    overlayStyle,
    overlayClassName = '',
    listHeight = 330,
    num = 2,
    value: defaultValue,
    options,
    buttonName,
    hasAllCheck = false,
    disabled,
    isShowButtonLabel = true,
    onChange,
    searchable,
    filter,
    tips,
    AWidth,
    ...restProps
  } = props;

  // console.log("TEXT", props)

  const { formatMessage } = useIntl();
  const [updateValue, setUpdateValue] = useState(false);

  // console.log('MulSelectorMulSelector', props);

  const optionsValus = options?.map((item) => item.value);
  const [value, setValue] = useState<string[]>(defaultValue);
  useEffect(() => {}, [options]);

  useEffect(() => {
    const realVal = optionsValus.filter((t: string) =>
      defaultValue.includes(t),
    );
    setValue(realVal?.length > 0 ? realVal : optionsValus);
  }, [defaultValue, options]);

  // 关闭时回调
  const onCloseAction = () => {
    if (!updateValue) {
      return;
    }
    // 全不选择时 恢复默认值
    const newVal = value?.length === 0 ? optionsValus : value;
    // setValue(optionsValus);
    setValue(newVal);
    if (onChange instanceof Function) {
      onChange(newVal);
    }
    setUpdateValue(false);
  };
  const button = () => {
    const valueUI = (() => {
      if (!value?.length)
        return (
          <span className="select-button-placeholder">
            {formatMessage({ id: 'dbi_please_select' })}
          </span>
        );
      if (value?.length === options?.length) {
        return <>{formatMessage({ id: 'dbi_all' })}</>;
      }
      if (value?.length >= num) return value?.length;
      const valueTmp = value?.sort(
        (a, b) =>
          // 勾选需要排序
          optionsValus?.indexOf(a) - optionsValus?.indexOf(b),
      );
      return valueTmp?.map((val, idx) => {
        const option = options?.find((t) => t?.value === val);
        const optionBtnText = option?.buttonText;
        const optionText = option?.text;
        const optionTextResult = optionBtnText || optionText;
        return valueTmp?.length === 1 || valueTmp?.length - 1 === idx ? (
          optionTextResult
        ) : (
          <>
            {optionTextResult}
            <span className="dbi-select-button-gap">, </span>
          </>
        );
      });
    })();

    return (
      <div className="dbi-select-button">
        {isShowButtonLabel && buttonName && (
          <span className="select-button-text">{buttonName}&nbsp;</span>
        )}
        {tips && (
          <div style={{ marginRight: 6, lineHeight: 0 }}>
            <TipContext
              Performance="left"
              AWidth={AWidth}
              tipText={formatMessage({ id: tips })}
            />
          </div>
        )}
        <span className="select-button-value">{valueUI}</span>
      </div>
    );
  };
  return (
    <SelectMultiple
      size="m"
      searchable={searchable}
      // 自定义搜索函数
      filter={
        filter instanceof Function
          ? (input, option) => filter(input, option)
          : undefined
      }
      style={style}
      className={classnames('select-item', className)}
      overlayStyle={overlayStyle}
      overlayClassName={overlayClassName}
      staging={false} // 不渲染确定和取消按钮
      listHeight={listHeight}
      appearance="button"
      matchButtonWidth
      button={button}
      value={value}
      onChange={(value) => {
        setUpdateValue(true);
        setValue(value);
      }}
      options={options}
      allOption={
        hasAllCheck
          ? {
              value: 'all',
              text: formatMessage({ id: 'dbi_all_select' }),
            }
          : undefined
      }
      onClose={onCloseAction}
      disabled={disabled}
      {...restProps}
    />
  );
}
export const renderImgText = (text: string, img = '') => {
  const { formatMessage } = useIntl();
  if (!img) {
    return (
      <span className="select-button-desc">
        {typeof text === 'string' ? formatMessage({ id: text }) : text}
      </span>
    );
  }

  return (
    <span className="dbi-select-button">
      <img
        style={{ width: 16, verticalAlign: 'middle', marginRight: 4 }}
        src={img}
        className={`${imgInvert.includes(text) ? 'db-invert-unset' : ''}`}
      />
      <span className="select-button-desc">{text}</span>
    </span>
  );
};
